module.exports = __webpack_public_path__ + "img/category-fishing-game-hover.963f65eb.png";